export enum BaseCoins {
  ETH = "ETH",
  BTC = "BTC",
  SOL = "SOL",
}

export enum TargetCoins {
  USD = "USD",
  EUR = "EUR",
  GBP = "GBP",
}
